module.exports = require("npm:noty@2.3.8/js/noty/packaged/jquery.noty.packaged.js");